function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
function SelectAll(props) {
  const {
    selectAllButtonProps
  } = props;
  const handleSelectAll = event => {
    event.preventDefault();
    if (selectAllButtonProps.onClick) {
      selectAllButtonProps.onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(Button, _extends({}, selectAllButtonProps, {
    variant: "tertiary",
    onClick: handleSelectAll
  }));
}
SelectAll.propTypes = {
  selectAllButtonProps: PropTypes.object
};
export default SelectAll;